import { AttachFile, Email } from '@mui/icons-material';
import { CircularProgress, IconButton } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { Booth, DataShare, Meetingroom } from '../../../../../../../interfaces/interfaces';
import { getTotalContactSharesInBooth } from '../../../../../../../services/services';
import EmailGuestModal from '../../../../../../account/EmailGuestModal';
import { VyExportButton } from '../../../../../../common/VyExportButton';
import VyNoData from '../../../../../../common/VyNoData';
import VyTooltip from '../../../../../../common/VyTooltip';
import ContactShareFilesModal from './BoothContactShare/ContactShareFilesModal';
import BoothContactShareModal from './BoothContactShareModal';
import { TabContentWrapper } from './TabContentWrapper';

interface LeadsTabInterface {
  booth: Booth;
}

interface Section {
  title: string;
  meetingrooms: Meetingroom[] | undefined;
  enabled: boolean | undefined;
  onAdd: Function;
}

const LeadsTab = ({ booth }: LeadsTabInterface) => {
  const { t } = useTranslation(['booth']);

  const [reports, setReports] = useState<DataShare[]>([]);
  const [selectedReport, setSelectedReport] = useState<DataShare>();
  const [files, setFiles] = useState<string[]>();
  const [notifyModal, setNotifyModal] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchContactShares = async () => {
    const _reports = await getTotalContactSharesInBooth(booth._id);
    setReports(_reports);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchContactShares();
  }, [booth._id]);

  return (
    <TabContentWrapper>
      <main className="pb-8  grid place-items-center">
        <div className="w-full p-2 text-slate-700">
          <div>
            <p>{t('account:contactshare-subtitle')}</p>
          </div>
        </div>
        {!isLoading ? (
          <>
            {reports.length > 0 && (
              <VyExportButton
                csvURL={`/reporting/booth/${booth._id}/contactshare?resType=csv`}
                xlsxURL={`/reporting/booth/${booth._id}/contactshare?resType=xlsx`}
                axiosMethod="GET"
              />
            )}
            {reports.length > 0 ? (
              reports.map((report) => (
                <div
                  className="w-full py-4 px-2 flex flex-row cursor-pointer bg-white hover:bg-blue-100 transition-colors border-b border-slate-200"
                  onClick={() => setSelectedReport(report)}>
                  <p className="w-1/3">{report.name}</p>
                  <p className="w-1/3">{report.email}</p>
                  <div className="w-1/6" onClick={(e) => e.stopPropagation()}>
                    <VyTooltip title={!report.files || report.files.length === 0 ? '' : 'see files'}>
                      <IconButton onClick={() => setFiles(report.files)} disabled={!report.files || report.files.length === 0}>
                        <AttachFile fontSize="small" />
                      </IconButton>
                    </VyTooltip>
                  </div>
                  <div className="w-1/6" onClick={(e) => e.stopPropagation()}>
                    <VyTooltip title={'Nachricht senden'}>
                      <IconButton onClick={() => setNotifyModal([report.email])}>
                        <Email fontSize="small" />
                      </IconButton>
                    </VyTooltip>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full h-full grid place-items-center p-8">
                <VyNoData noDataText={t('pagebuilder:no-leads')} />
              </div>
            )}
          </>
        ) : (
          <div className="w-full h-full grid place-items-center">
            <CircularProgress />
          </div>
        )}
      </main>
      {selectedReport && <BoothContactShareModal report={selectedReport} onClose={() => setSelectedReport(undefined)} />}
      {!!files && <ContactShareFilesModal files={files} onClose={() => setFiles(undefined)} />}
      <EmailGuestModal emails={notifyModal} onClose={() => setNotifyModal([])} boothId={booth._id} />
    </TabContentWrapper>
  );
};
export default LeadsTab;
